<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h720_dialog abow_dialog"
      width="1200px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="省区">
                    <el-input
                      v-model="dialogAddEditViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="城市">
                    <el-input
                      v-model="dialogAddEditViewForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="方案名称">
                    <el-input
                      v-model="dialogAddEditViewForm.schemeName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="方案编号">
                    <el-input
                      v-model="dialogAddEditViewForm.schemeNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="类型">
                    <el-input
                      v-model="dialogAddEditViewForm.sortStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="人员名称">
                    <el-input
                      v-model="dialogAddEditViewForm.userName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="活动日期">
                    <el-input
                      v-model="dialogAddEditViewForm.activityDateStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="活动时间段">
                    <el-input
                      v-model="dialogAddEditViewForm.activityTimeStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="活动场次">
                    <el-input
                      v-model="dialogAddEditViewForm.fieldTypeStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="活动场所">
                    <el-input
                      v-model="dialogAddEditViewForm.storeName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    :label="inOutType === 1 ? '签到时间' : '签退时间'"
                    prop="signTime"
                  >
                    <el-date-picker
                      v-model="dialogAddEditViewForm.signTime"
                      type="datetime"
                      style="width: 100%;"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    :label="(inOutType === 1 ? '签到地址' : '签退地址') + ' (例：XX市XX区(县)XX路(街)XX号)'"
                    prop="signAddress"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.signAddress"
                    >
                      <el-tooltip
                        slot="suffix"
                        effect="dark"
                        content="点击定位"
                        placement="top"
                      >
                        <i
                          class="el-input__icon el-icon-location-information"
                          style="color:red;font-size:18px;"
                          @click="getAddressGPSFun()"
                        />
                      </el-tooltip>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label=" "
                  >
                    <span style="color: red;">输入地址后请点击输入框后图标进行定位</span>
                  </el-form-item>
                </el-col>
                <!-- <el-col
                  :span="24"
                  style="padding-bottom: 5px;min-height: 20px;padding-top: 20px;"
                >
                  <span style="color: red;">注：点击坐标变更为粉色后，坐标可以拖动</span>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="地图位置">
                    <div
                      id="container"
                      ref="container"
                      :style="{width:'1100px',height: '400px' }"
                      class="map-container"
                    />
                  </el-form-item>
                </el-col> -->
              </el-row>
            </div>
          </div>
          <div
            v-if="eventType !== 'view'"
            class="modal-box pic-container"
          >
            <h3 class="modal-title">
              {{ inOutType === 1 ? '签到' : '签退' }}照片信息<span style="padding-left:30px;color:red">上传图片大小：小于10M; 格式：png、jpg、jpeg、gif;</span>
            </h3>
            <div class="modal-row-box">
              <el-upload
                ref="picUpload"
                list-type="picture-card"
                :action="picUploadAction"
                :data="picData"
                :before-upload="beforeAvatarUpload"
                :file-list="initFileList"
                :on-preview="handlePictureCardPreview"
                :headers="{'X-Token': getToken()}"
                multiple
                accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PNG,.GIF"
                :with-credentials="true"
                :on-success="function (res, file, fileList) {return handleSuccess (res, file, fileList, picList)}"
                :on-remove="(file,fileList)=>handlePictureCardRemove(file,fileList,picList)"
              >
                <el-button
                  type="success"
                  class="upload-button"
                  icon="el-icon-folder-opened"
                >
                  选择图片
                </el-button>
              </el-upload>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          :disabled="operateButtonDisable"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
      <el-dialog
        :visible.sync="dialogImageVisible"
        append-to-body
      >
        <img
          width="100%"
          :src="dialogImageUrl"
          alt=""
        >
      </el-dialog>
    </el-dialog>
  </div>
</template>
<script>
import markerPink from '@/assets/png/markerPink.png'
// 数据请求
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
import { findAttachmentInfoByConditionApi, deleteFileApi, findGpsLocationByAddressApi } from '@/api/common'
import { initActivitySignInOutInfoApi, saveOrUpdateActivitySignInOutInfoApi } from '@/api/activitySignInOutInfo'
import { getToken } from '@/utils/auth'
import AMapLoader from "@amap/amap-jsapi-loader";
export default {
  components: { },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    inOutType: {
      type: Number,
      default: null
    },
    operateType: {
      type: Number,
      default: null
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: true,
      operateButtonDisable: false,
      dialogAddEditViewForm: {
      },
      dialogAddEditViewFormRules: {
        signTime: [{ required: true, message: '请选择签到签退时间', trigger: 'change' }],
        signAddress: [{ required: true, message: '请录入签到签退地址', trigger: 'blur' }],
        remark: [{ max: 512, message: '最多输入512个字符', trigger: 'blur' }]
      },
      regionIds: '',
      dialogSchemeVisible: false,
      dialogEmployeeVisible: false,
      //上传相关
      picData: { directory: 'activitySignInOutInfo', sort: 999 },
      picUploadAction: '',
      initFileList: [],
      dialogImageUrl: '',
      dialogImageVisible: false,
      picList: [], // 照片对象数组
      baseUrl: '',
      //地图相关
      markerPink: markerPink,
      gpsMap: null, // 地图底层
      gpsMarker: null, //标记数组
      gpsInfo: null, //提示框
      mapEditor: null //地图标记操作层
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.operateButtonDisable = false
        this.baseUrl = process.env.VUE_APP_BASE_API
        this.picUploadAction = process.env.VUE_APP_BASE_API + '/web/common/uploadFile'
        this.picList = []
        this.initFileList = []
        this.dialogAddEditViewForm = {
          id: '',
          provinceName: '',
          cityName: '',
          schemeName: '',
          schemeNo: '',
          userName: '',
          storeName: '',
          sortStr: '',
          activityDateStr: '',
          activityTimeStr: '',
          fieldTypeStr: '',
          signTime: '',
          signAddress: '',
          lng: '',
          lat: '',
          remark: ''
        }
        this.initPageData()
      }
    }
  },
  methods: {
    getToken,
    // 加载数据
    initPageData() {
      initActivitySignInOutInfoApi({ id: this.dataId }).then(res => {
        const { data } = res
        for (let key in this.dialogAddEditViewForm) {
          this.dialogAddEditViewForm[key] = data[key]
        }
        this.dialogAddEditViewForm.id = data.id
        // 补签初始化地址
        if(this.operateType === 1){
          if(data.isSignIn === 0 || data.isSignOut === 0){
            this.dialogAddEditViewForm.signAddress = data.storeAddress
            this.dialogAddEditViewForm.signTime = null
          }
        } else {
          if(this.inOutType === 1){
            // 签到
            this.dialogAddEditViewForm.signAddress = data.signInAddress
            this.dialogAddEditViewForm.signTime = data.signInTimeStr
            this.dialogAddEditViewForm.lng = data.signInLng
            this.dialogAddEditViewForm.lat = data.signInLat
          } else {
            this.dialogAddEditViewForm.signAddress = data.signOutAddress
            this.dialogAddEditViewForm.signTime = data.signOutTimeStr
            this.dialogAddEditViewForm.lng = data.signOutLng
            this.dialogAddEditViewForm.lat = data.signOutLat
          }
        }
        let sourceType = 20
        if(this.inOutType === 2){
          sourceType = 21
        }
        findAttachmentInfoByConditionApi({ sourceType: sourceType, sourceId: data.id }).then(res1 => {
          if (res1.data && res1.data.length > 0) {
            res1.data.forEach(item => {
              let obj = {}
              obj.name = item.attachmentName
              obj.url = this.baseUrl + item.attachmentUrl
              obj.attachmentName = item.attachmentName
              obj.attachmentUrl = item.attachmentUrl
              this.picList.push(obj)
              this.initFileList.push(obj)
            })
          }
        })
        // if(this.operateType === 1){
        //   this.initMap2(0,0)
        // } else {
        //   this.initMap2(this.dialogAddEditViewForm.lat,this.dialogAddEditViewForm.lng)
        // }
        this.loading = false
      })
    },
    // 图片上传前
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 10
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过10MB!')
        return false
      }
      this.isUploading = true
    },
    // 预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogImageVisible = true
    },
    // 上传成功
    handleSuccess(res, file, fileList, dataObj) {
      if (res.mark === '200') {
        let fileObj = {}
        fileObj.attachmentName = res.myFileName
        fileObj.attachmentUrl = res.fileName
        fileObj.url = this.baseUrl + res.fileName
        dataObj.push(fileObj)
        this.isUploading = false
      } else {
        this.$message.error(res.message)
      }
    },
    // 删除
    handlePictureCardRemove(file, fileList, dataObj) {
      let fileUrl = ''
      if (file.response) {
        let resData = file.response
        let delIndex = dataObj.findIndex(item => {
          return item.attachmentUrl === resData.fileName
        })
        fileUrl = resData.fileName
        dataObj.splice(delIndex, 1)
      } else {
        let delIndex = dataObj.findIndex(item => {
          if (item.url === file.url) {
            fileUrl = item.attachmentUrl
            return item.url === file.url
          }
        })
        dataObj.splice(delIndex, 1)
      }
      if (fileUrl !== '') {
        deleteFileApi({ filePath: fileUrl }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
          }
        })
      }
    },
    initMap2(lat,lng) {
      let _this = this
      if(Number(lat) === 0){
        lat = 30.657000
        lng = 104.066002
      }
      window._AMapSecurityConfig = {
        securityJsCode: "633bc5cb2162fdb3c4a8e5d2d5aa0daa",
      };
      AMapLoader.load({
        key: "f21da6bcb395bf6636a0cfdfce27bb8f", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.Scale"], //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
      })
        .then((AMap) => {
          _this.gpsMap = new AMap.Map("container", {
            // 设置地图容器id
            viewMode: "2D", // 是否为3D地图模式
            zoom: 16, // 初始化地图级别
            center: [lng, lat], // 初始化地图中心点位置
          });
          _this.gpsMarker = new AMap.Marker({
              map: _this.gpsMap,
              icon: new AMap.Icon({
                image:_this.markerPink,
                imageSize: new AMap.Size(36, 50)
              }),
              position: [lng, lat],
              anchor: 'bottom-center',
              draggable: true
          });
          _this.gpsMarker.on("dragend",function(event){
            _this.dialogAddEditViewForm.lat = event.lnglat.lat
            _this.dialogAddEditViewForm.lng = event.lnglat.lng
          })
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 初始化地图
    initMap(lat,lng) {
        //定义地图中心点坐标
        let center = null
        let _this = this
        if(Number(lat) === 0){
          center = new TMap.LatLng(30.657000, 104.066002)
        } else {
          center = new TMap.LatLng(lat, lng)
        }
        //定义map变量，调用 TMap.Map() 构造函数创建地图
        _this.gpsMap = new TMap.Map(_this.$refs.container, {
            center: center,//设置地图中心点坐标
            zoom: 16,   //设置地图缩放级别
            draggable: true,
            scrollable: true,
        });
        // 创建一个Marker
        _this.gpsMarker = new TMap.MultiMarker({
          map: _this.gpsMap,
          styles: {
            "highlight": new TMap.MarkerStyle({
              "src": _this.markerPink
            }),
          },
          geometries: [
            // 点标记数据数组
            {
              id: 'marker',
              "position": center,
            }
          ],
        });
        // 初始化几何图形及编辑器
        _this.mapEditor = new TMap.tools.GeometryEditor({
          map: _this.gpsMap, // 编辑器绑定的地图对象
          overlayList: [{
            overlay: _this.gpsMarker, // 可编辑图层
            id: "marker",
            selectedStyleId: "highlight"  // 被选中的marker会变为高亮样式
          }],
          actionMode: TMap.tools.constants.EDITOR_ACTION.INTERACT, // 编辑器的工作模式
          activeOverlayId: "marker", // 激活图层
          selectable: true
        });
        // 拖拽获取gps位置
        _this.mapEditor.on("adjust_complete", function(event){
          _this.dialogAddEditViewForm.lat = event.position.lat
          _this.dialogAddEditViewForm.lng = event.position.lng
        })
    },
    getAddressGPSFun(){
      let _this = this
      if(_this.dialogAddEditViewForm.signAddress === undefined || _this.dialogAddEditViewForm.signAddress === null || _this.dialogAddEditViewForm.signAddress.trim() === ''){
        _this.$message({
          message: '请输入地址信息',
          type: 'warning'
        })
        return false
      }
      let address = _this.dialogAddEditViewForm.provinceName + (_this.dialogAddEditViewForm.provinceName === '重庆市' ? '' : _this.dialogAddEditViewForm.cityName) + _this.dialogAddEditViewForm.signAddress
      findGpsLocationByAddressApi({address: address}).then((response) => {
        let locationInfo = response.data
        _this.dialogAddEditViewForm.lat = locationInfo.lat
        _this.dialogAddEditViewForm.lng = locationInfo.lng
        // let currentPosition = new TMap.LatLng(locationInfo.lat, locationInfo.lng)
        // _this.gpsMarker.updateGeometries([
        //   {
        //     id: 'marker',
        //     position: currentPosition, // 将得到的坐标位置用点标记标注在地图上
        //   },
        // ]);
        // _this.gpsMap.setCenter(currentPosition);
        // _this.mapEditor.removeOverlay('marker')
        // _this.mapEditor.addOverlay({
        //   overlay: _this.gpsMarker, // 可编辑图层
        //   id: "marker",
        //   selectedStyleId: "highlight"  // 被选中的marker会变为高亮样式
        // })
        
        // _this.gpsMap.setCenter([locationInfo.lng, locationInfo.lat])
        // _this.gpsMarker.setPosition([locationInfo.lng, locationInfo.lat])
      });
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose() {
      if(this.gpsMap){
        this.gpsMap.destroy()
      }
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave() {
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          if(this.dialogAddEditViewForm.lng === undefined || this.dialogAddEditViewForm.lng === null || this.dialogAddEditViewForm.lng === 0){
            this.$message({
              message: '请点击地址信息后定位按钮获取定位',
              type: 'warning'
            })
            return false
          }
          if(this.picList.length === 0){
            this.$message({
              message: '请上传' + (this.inOutType === 1 ? '签到照片' : '签退照片'),
              type: 'warning'
            })
            return false
          }
          this.$confirm(
            '是否确定修改' + (this.inOutType === 1 ? '签到' : '签退') + '信息', '系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              this.operateButtonDisable = true
              let attachmentInfo = []
              this.picList.forEach(item => {
                let obj = {
                  attachmentUrl: item.attachmentUrl,
                  attachmentName: item.attachmentName
                }
                attachmentInfo.push(obj)
              })
              this.dialogAddEditViewForm.attachmentInfoData = JSON.stringify(attachmentInfo)
              this.dialogAddEditViewForm.isChange = 1
              this.dialogAddEditViewForm.operateType = this.operateType
              this.dialogAddEditViewForm.inOutType = this.inOutType
              this.handlerSave()
            })
            .catch(() => {
              this.operateButtonDisable = false
            })
        }
      })
    },
    // 保存
    handlerSave() {
      saveOrUpdateActivitySignInOutInfoApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
        this.operateButtonDisable = false
      })
    },
  }
}
</script>
<style lang="scss"  scoped>
.pic-container {
  position: relative;
  .pic-name {
    display: inline-block;
    padding-top: 7px;
    margin-bottom: 10px;
  }
  .upload-button {
    position: absolute;
    top: 0;
    right: 0px;
  }
  ::v-deep .el-upload--picture-card i {
    font-size: 14px !important;
    color: #fff !important;
  }
  ::v-deep .el-upload--picture-card {
    border: none;
    height: 0px;
    overflow: hidden;
  }
}
::v-deep .el-upload-list--picture-card {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  .el-upload-list__item {
    display: flex;
    flex: 0 0 218px;
    margin-right: 8px;
    width: 218px;
    height: 218px;
    align-items: center;
    border-radius: 0;
  }
  .el-upload-list__item-thumbnail {
    height: auto;
    align-items: center;
  }
}
.map-container {
  padding-top: 5px;
}
</style>
